import { Type } from 'class-transformer';

export enum ClassroomActivityType {
	LearningHub = 'learning_hub',
	PodHub = 'pod_hub',
	Recess = 'recess',
	Study = 'study',
	YourTurn = 'your_turn',
	Unstructured = 'unstructured',
}

export class ClassroomActivityModel {
	activity_id: number;
	days: number[];
	type: ClassroomActivityType;
	course_id: number;
	course_name: string;
	description: string;
	meetup_owner_uid: number;
	auto: boolean;
	cohost_uids: number[];
	meetup_link: string;
	associated_meetup_id: number | null;
	associated_meetup_host_name: string;
	associated_meetup_link: string;
}

export function ClassroomActivityModel_ClassTransform_Type() {
	return ClassroomActivityModel;
}

export class ClassroomPeriodModel {
	period_id: number;
	start_time: string;
	end_time: string;
	@Type(ClassroomActivityModel_ClassTransform_Type)
	activities: ClassroomActivityModel[];
}

export function ClassroomPeriodModel_ClassTransform_Type() {
	return ClassroomPeriodModel;
}

export class ClassroomModel {
	id: number;
	classroom_name: string;
	session_id: number;
	session_name: string;
	timezone: string;
	status: string;
	@Type(ClassroomPeriodModel_ClassTransform_Type)
	periods: ClassroomPeriodModel[];
}

export function ClassroomModel_ClassTransform_Type() {
	return ClassroomModel;
}

export interface ClassroomActivityArgument {
	days: number[];
	type: ClassroomActivityType;
	course_id: number;
	description: string;
	meetup_owner_uid: number;
	auto: boolean;
	cohost_uids: number[];
	meetup_link: string;
	/** Only passed for edit or delete */
	id: number;
	/** Only pass when applicable with delete = true */
	delete: boolean;
}

export interface ClassroomPeriodArgument {
	start_time: string;
	end_time: string;
	activities: ClassroomActivityArgument[];
	/** Only passed for edit or delete */
	id: number;
	/** Only pass when applicable with delete = true */
	delete: boolean;
}

export interface ClassroomArgument {
	classroom_name: string;
	session_id: number;
	timezone: string;
	periods: Partial<ClassroomPeriodArgument>[];
}
